const QueryKeys = {
  industriesByCategory: 'industriesByCategory',
  rankingList: 'rankingList',
  auth: 'auth',
  companySalary: 'companySalary',
  companySalaryChart: 'companySalaryChart',
  companyInfo: 'companyInfo',
  companyIdFromHash: 'companyIdFromHash',
  companySummary: 'companySummary',
  companyStates: 'companyStates',
  companyRelations: 'companyRelations',
  companySuggestion: 'companySuggestion',
  companyEmployee: 'companyEmployee',
  companyEmployeeAvgService: 'companyEmployeeAvgService',
  companyEmployeeChart: 'companyEmployeeChart',
  companyFinancialChart: 'companyFinancialChart',
  companyReviewWorkLife: 'companyReviewWorkLife',
  companyReviewCulture: 'companyReviewCulture',
  companyReviewInterview: 'companyReviewInterview',
  companySkillList: 'companySkillList',
  jobdomList: 'jobdomList',
  companyWikiSalary: 'companyWikiSalary',
  wikiSalaryList: 'wikiSalaryList',
  companySales: 'companySales',
  autoComplete: 'autoComplete',
  jobCategory: 'jobCategory',
  getMyWiki: 'getMyWiki',
  wikiSuggestion: 'wikiSuggestion',
  jobdom: 'jobdom',
  favoriteCompany: 'favoriteCompany',
  myInfo: 'myInfo',
  career: 'career',
  onboardingCompany: 'onboardingCompany',
  onboardingIndustry: 'onboardingIndustry',
  onboardingJob: 'onboardingJob',
  onboardingTag: 'onboardingTag',
  bookmark: 'bookmark',
  wantedJobPosting: 'wantedJobPosting',
  industries: 'industries',
  skillKeyword: 'skillKeyword',
  userSkill: 'userSkill',
  categorySkills: 'categorySkills',
  companySkills: 'companySkills',
} as const;
export default QueryKeys;
